var REG_EX = /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[a-z]+[-a-z0-9_]*)*\.([a-z][a-z]+|((?!-))(xn--)+[a-z0-9][a-z0-9-_]{0,61}[a-z0-9]{0,1}(\.)?(xn--)*([a-z0-9-]{1,61}|[a-z0-9-]{1,30}\.[a-z]{2,}))|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
export default (function (email) {
  return REG_EX.test(email);
});